import { render, staticRenderFns } from "./ListOfInternmentToday.vue?vue&type=template&id=00b6e085&scoped=true&"
import script from "./ListOfInternmentToday.vue?vue&type=script&lang=js&"
export * from "./ListOfInternmentToday.vue?vue&type=script&lang=js&"
import style0 from "./ListOfInternmentToday.vue?vue&type=style&index=0&id=00b6e085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6e085",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VIcon,VProgressCircular,VRow,VSimpleTable})
